import React, { useState, useEffect, useRef } from "react";
import videojs from "video.js";
import useIntersectionObserver from "hooks/useIntersectionObserver";
// import vtsrc from "assets/audio/AnnouncementTest.vtt";

export default ({
  src,
  autoplay = false,
  controls = true,
  played = () => {},
  mediaCaptions,
  style,
}) => {
  const videoRef = useRef(null);
  const [player, setPlayer] = useState(null);

  useIntersectionObserver({
    target: videoRef,
    threshold: [0.25, 0.75],
    onIntersect: ([{ isIntersecting }], observerElement) => {
      if (!isIntersecting) {
        videoRef.current.pause();
      }
    },
  });

  useEffect(() => {
    const vjsPlayer = videojs(videoRef.current, {
      ...{
        fill: true,
        fluid: false,
        preload: "metadata",
        bigPlayButton: true,
        textTrackSettings: true,
        nativeTextTracks: false,
        html5: {
          nativeTextTracks: false,
          hls: {
            enableLowInitialPlaylist: true,
            smoothQualityChange: true,
            overrideNative: true,
            textTrackSettings: true,
            nativeTextTracks: false,
          },
        },
      },
      controls,
      autoplay,
      sources: [src],
      aspectRatio: "2:1",
    });

    vjsPlayer.on("play", () => {
      played();
    });

    setPlayer(vjsPlayer);

    return () => {
      if (player !== null) {
        player.dispose();
        setPlayer(null);
      }
    };

    // eslint-disable-next-line
  }, []);

  return (
    <div style={{ position: "relative" }}>
      <video
        src={src}
        ref={videoRef}
        preload="metadata"
        className="video-js vjs-default-skin vjs-big-play-centered"
        playsInline
        style={style}
      >
        <track
          kind="captions"
          src={mediaCaptions}
          srcLang="en"
          label="English"
          default
        ></track>
      </video>
    </div>
  );
};
